module.exports = __webpack_public_path__ + "img/34.0933720c.jpg";